// import * as React from 'react';
import * as PropTypes from 'prop-types';
import classNames from 'clsx';
import { withStyles } from '@material-ui/core/styles';
import {Actions as CHANGELOGACTIONS} from 'store/changelog/action';
import React, { useState, useEffect } from "react";
import { format } from "date-fns";
import {connect} from 'react-redux';
import IconButton from '@material-ui/core/IconButton';
import Tooltip from '@material-ui/core/Tooltip';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogActions from '@material-ui/core/DialogActions';
import Button from '@material-ui/core/Button';
import ReceiptIcon from '@material-ui/icons/Receipt';
import { API } from '@aws-amplify/api';
import { Auth } from '@aws-amplify/auth';

const styles = ({ spacing, palette }) => ({
  head: {
    position: 'relative',
    paddingLeft: spacing(1),
    paddingRight: spacing(0.5),
    paddingTop: spacing(0.25),
    minHeight: spacing(1.5),
  },
  line: {
    backgroundColor: palette.action.disabledBackground,
    height: spacing(3.5),
    marginLeft: spacing(1),
    marginRight: spacing(1),
    marginTop: spacing(1.25),
    width: '1px',
  },
  flexContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-end',
    alignItems: 'flex-start',
  },
});

const HeaderBase = ({
  appointmentData,
  commandButtonComponent: CommandButton,
  showOpenButton,
  showCloseButton,
  showDeleteButton,
  commandButtonIds,
  onOpenButtonClick,
  onDeleteButtonClick,
  onHide,
  classes,
  className,
  children,
  changelog,
  teamMembers,
  permissions,
  toggleChangeLogModal,
  getChangelogByEntity,
  ...restProps
}) => {

  const [resendOpen, setResendOpen] = useState(false);
  const [resending, setResending] = useState(false);
  const [resendError, setResendError] = useState(null);

  const handleResendReceipt = async () => {
    try {
      setResending(true);
      setResendError(null);
      const token = (await Auth.currentSession()).getAccessToken().getJwtToken();
      await API.post('booking', '/bookings/resendPos', {
        body: { bookingID: appointmentData.id },
        headers: { Authorization: `Bearer ${token}` },
      });
      setResendOpen(false);
    } catch (err) {
      console.error('resendPos failed', err);
      setResendError('Failed to resend receipt. Please try again.');
    } finally {
      setResending(false);
    }
  };

  useEffect(() => {
    console.log('Update changelog',appointmentData,appointmentData.id)
    if (appointmentData.id){
      getChangelogByEntity(appointmentData.id)
    }
  },[appointmentData && appointmentData.id]);

  const handleOpenButtonClick = () => {
    onHide();
    onOpenButtonClick();
  };

  const lastChangeLog = changelog && changelog[0]
  const lastModifiedBy = lastChangeLog && teamMembers.find(({id}) => id == lastChangeLog.teamMemberID)
  let lastModifiedToDisplay;
  if (lastModifiedBy) {
    lastModifiedToDisplay = `${lastModifiedBy.givenName} ${lastModifiedBy.familyName}`;
  } else if (lastChangeLog) {
    let lastChangeLogDiff = {};
    try {
      lastChangeLogDiff = JSON.parse(lastChangeLog.diff);
    } catch (e) {
      console.error("Error parsing diff:", e);
    }
    if (lastChangeLogDiff?.lastModifiedBy) {
      lastModifiedToDisplay = lastChangeLogDiff.lastModifiedBy;
    }
  }
  if (!lastModifiedToDisplay) lastModifiedToDisplay = "Client";
  
  const lastModifiedDate = lastChangeLog && format(new Date(lastChangeLog.createdAt),"d MMM yyyy hh:mm")

  console.log("lastModifiedBy",lastModifiedBy)
  console.log("createdAt",lastChangeLog && lastChangeLog.createdAt,lastModifiedDate)

  return (
    <div
      className={classNames(classes.head, classes.flexContainer, className)}
      {...restProps}
    >
      { lastChangeLog && 
        <div 
          style={{
            width: "100%",
            cursor: "pointer",
          }}
          onClick={ () => {
            toggleChangeLogModal()
            onHide()
          }}
        >
          Last modified by <strong>{lastModifiedToDisplay}</strong> 
          <br/> at {lastModifiedDate}
        </div>
      }
      {permissions === "Admin" && appointmentData && appointmentData.id && (
        <Tooltip title="Resend Receipt">
          <IconButton
            aria-label="Resend Receipt"
            onClick={(e) => {
              e.stopPropagation();
              setResendError(null);
              setResendOpen(true);
            }}
          >
            <ReceiptIcon />
          </IconButton>
        </Tooltip>
      )}
      {showOpenButton && (
        <CommandButton id={commandButtonIds.open} onExecute={handleOpenButtonClick} />
      )}
      {showDeleteButton
        && <CommandButton id={commandButtonIds.delete} onExecute={onDeleteButtonClick} />}
      {children}
      {showCloseButton && (
        <div className={classes.flexContainer}>
          <div className={classes.line} />
          <CommandButton id={commandButtonIds.close} onExecute={onHide} />
        </div>
      )}
      <Dialog
        open={resendOpen}
        onClose={() => !resending && setResendOpen(false)}
        onClick={(e) => e.stopPropagation()}
      >
        <DialogTitle>Resend Receipt</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Are you sure you want to resend the receipt for this booking to the POS?
          </DialogContentText>
          {resendError && (
            <DialogContentText style={{ color: "red" }}>{resendError}</DialogContentText>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setResendOpen(false)} disabled={resending}>
            Cancel
          </Button>
          <Button onClick={handleResendReceipt} color="primary" disabled={resending}>
            {resending ? "Sending..." : "Resend"}
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

HeaderBase.propTypes = {
  classes: PropTypes.object.isRequired,
  appointmentData: PropTypes.object,
  children: PropTypes.node,
  className: PropTypes.string,
  commandButtonComponent: PropTypes.oneOfType([PropTypes.func, PropTypes.object]).isRequired,
  showOpenButton: PropTypes.bool.isRequired,
  showCloseButton: PropTypes.bool.isRequired,
  showDeleteButton: PropTypes.bool.isRequired,
  commandButtonIds: PropTypes.object.isRequired,
  onOpenButtonClick: PropTypes.func,
  onDeleteButtonClick: PropTypes.func,
  onHide: PropTypes.func,
  permissions: PropTypes.string,
};

HeaderBase.defaultProps = {
  appointmentData: undefined,
  className: undefined,
  children: undefined,
  onOpenButtonClick: () => undefined,
  onDeleteButtonClick: () => undefined,
  onHide: () => undefined,
};

const mapStateToProps = (state) => {
  console.log('state',state && state.business)
    return {
      changelog: state.changelog && state.changelog.items,
      teamMembers: state.teamMember.list,
      permissions: state.permissions,
  }
}

const mapDispatchToProps = dispatch => ({
  getChangelogByEntity: (item) => dispatch(CHANGELOGACTIONS.getChangelogByEntity(item)),
  toggleChangeLogModal: () => dispatch(CHANGELOGACTIONS.toggleChangeLogModal(true)),
});

const HeaderWithStyles = withStyles(styles, { name: 'Header' })(HeaderBase);

export const Header = connect(
  mapStateToProps,
  mapDispatchToProps
)(HeaderWithStyles)


